<div class="fe-toggle" [ngClass]="{'fe-toggle-text-left': textDirection === 'LEFT', 'littleMode': littleMode}">
    <mat-slide-toggle (change)="valueChange.emit(inputValue)" [(ngModel)]="inputValue"/>
    <span class="fe-toggle-text" *ngIf="text != ''">{{text}}</span>
</div>